export default __webpack_public_path__ + "static/media/Steelspirit Girdle.05966a58.jpg";